import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Carousel } from "./carousel";
export const CarouselSSRWrapper = (props) => {
    const [showChild, setShowChild] = useState(false);
    // Wait until after client-side hydration to show
    useEffect(() => {
        setShowChild(true);
    }, []);
    if (!showChild) {
        return _jsx(_Fragment, {});
    }
    return _jsx(Carousel, Object.assign({}, props));
};
